import { Component, OnInit } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ConstantService } from 'src/app/services/constant/constant.service';
import { ConsumptionLimitService } from 'src/app/services/consumption-limit/consumption-limit.service';
import { CustomStorageService } from 'src/app/services/custom-storage/custom-storage.service';
import { EnterpriseService } from 'src/app/services/enterprise/enterprise.service';

@Component({
  selector: 'app-consumption-ceiling',
  templateUrl: './consumption-ceiling.component.html',
  styleUrls: ['./consumption-ceiling.component.scss'],
})
export class ConsumptionCeilingComponent implements OnInit {
  consumptionCeiling: any = {};
  accessOffer: any;
  isContractActive = false;
  enterprise: any;
  loadConsumptionLimit = false;
  users: any;
  Load = false;
  enterpriseData: any;
  disabledButton = false;
  dateReset;

  constructor(
    private readonly constantService: ConstantService,
    private readonly translate: TranslateService,
    private readonly storageService: CustomStorageService,
    private readonly consumptionLimitService: ConsumptionLimitService,
    private readonly enterpriseService: EnterpriseService,
    private readonly authService: AuthService
  ) { }

  ngOnInit(): void {

    this.dateReset = [
      { name: this.translate.instant('never'), code: 'Never' },
      { name: this.translate.instant('monthly'), code: 'Monthly' },
      { name: this.translate.instant('annual'), code: 'Annual' },
    ];

    this.enterprise = JSON.parse(localStorage.getItem('enterprise'));
    this.loadConsumptionLimit = true;
    if (this.enterprise.hasActiveContract === true) {
      this.isContractActive = true;
    }

    this.enterpriseService
      .getEnterpriseById(this.enterprise.id)
      .subscribe((data: any) => {
        this.enterprise = data.enterprise;
        this.storageService.setEnterprise(this.enterprise);

        if (this.enterprise.consumptionLimit) {
          this.consumptionLimitService
            .getConsumptionById(this.enterprise.consumptionLimit)
            .subscribe(
              (Consumption: any) => {
                this.loadConsumptionLimit = false;
                this.consumptionCeiling = Consumption['cspLimit'];
                this.consumptionCeiling.charge = this.consumptionCeiling.charge.toString();
              },
              (error) => {
                this.loadConsumptionLimit = false;
                switch (error.status) {
                  case 400:
                    this.constantService.showErrorToast('toast.error_consumption_ceiling');
                }
              }
            );
        } else {
          this.loadConsumptionLimit = false;
          this.consumptionCeiling = {
            enterprise: this.enterprise.id,
            amount: 0,
            reset: 'Never',
            charge: false,
          };

          this.consumptionLimitService
            .createConsumption(this.consumptionCeiling)
            .subscribe(
              (res) => {
                this.enterprise.consumptionLimit = res['limit']._id;
                this.consumptionLimitService.postConsumption(
                  this.enterprise.id
                );
              },
              (error) => {
                switch (error.status) {
                  case 401:
                    this.authService.logout();
                    break;
                }
              }
            );
        }
      });
  }

  /**
   * function is called to open contract page.
   */
  goContract() {
    this.constantService.navigateToAddContract();
  }

  /**
   * function is called to create plafond for one user.èu
   */
  createPlafond() {
    this.Load = true;
    this.consumptionCeiling.enterprise = this.enterprise.id;
    this.consumptionLimitService
      .putConsumption(this.consumptionCeiling, this.enterprise.consumptionLimit)
      .subscribe(
        (res) => {
          this.Load = false;
          this.constantService.showSuccessToast('toast.success-add_consumption_ceiling');
        },
        (error) => {
          this.Load = false;
          switch (error.status) {
            case 400:
              this.constantService.showErrorToast('toast.error_consumption_ceiling');
              break;
            case 401:
              this.authService.logout();
              break;
            default:
              this.constantService.showErrorToast('toast.error_server');
              break;
          }
        }
      );
  }
}
